import { render, staticRenderFns } from "./PolicyReissueDialog.vue?vue&type=template&id=30a4a8d8&"
import script from "./PolicyReissueDialog.vue?vue&type=script&lang=js&"
export * from "./PolicyReissueDialog.vue?vue&type=script&lang=js&"
import style0 from "./PolicyReissueDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports